import TaggedModal from '@components/TaggedModal';
import { TaggedTextArea } from '@components/inputs';
import { useUpdateCommentTemplate } from '@modules/comment/src/commentMutations';
import { Descriptions, Form } from 'antd';
import styles from './styles.module.less';

interface UpdateCommentTemplateModalProps {
  showModal: boolean
  closeModal: () => void
  selectedTemplate: comment.CommentTemplateData
}

const UpdateCommentTemplateModal = (props: UpdateCommentTemplateModalProps) => {
  const { showModal, closeModal, selectedTemplate } = props;

  const { mutate, isLoading } = useUpdateCommentTemplate(closeModal);

  const onSubmit = (values: comment.UpdateCommentTemplateFormData) => {
    mutate({ description: values.description, templateId: selectedTemplate.id });
  };

  return (
    <TaggedModal
      tag="updateCommentTemplate"
      title="Update Comment Template"
      centered
      destroyOnHidden
      open={showModal}
      okText="Submit"
      okButtonProps={{ htmlType: 'submit', form: 'updateCommentTemplateDescriptionForm', loading: isLoading }}
      onCancel={closeModal}
      width="80%"
    >
      <Descriptions labelStyle={{ fontWeight: 'bold' }} title="Template Details">
        <Descriptions.Item label="ID">{selectedTemplate.id}</Descriptions.Item>
        <Descriptions.Item label="Name">{selectedTemplate.name}</Descriptions.Item>
      </Descriptions>
      <Form id="updateCommentTemplateDescriptionForm" onFinish={onSubmit} initialValues={selectedTemplate} layout="vertical">
        <Form.Item
          name="description"
          required
          label="Description"
          rules={[{ required: true }]}
        >
          <TaggedTextArea tag="commentTemplateDescription" rows={3} />
        </Form.Item>
      </Form>
      <Descriptions>
        <Descriptions.Item>
          <span className={styles['asterisk-color-danger']}>
            {'**\u00A0'}
          </span>
          To replace the investment note name, please insert
          <strong>
            {'\u00A0<investmentNoteName>\u00A0'}
          </strong>
          in your comment template.
        </Descriptions.Item>
      </Descriptions>
    </TaggedModal>
  );
};

export default UpdateCommentTemplateModal;
